import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { extractContext } from '../context';
import { extractType } from './extractType';

/**
 * @deprecated Use extractSmartLinkTitle instead
 */
export var extractTitle = function extractTitle(jsonLd, removeTextHighlightingFromTitle) {
  var _jsonLd$name;
  if (!jsonLd) {
    return undefined;
  }
  var name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
  var id = jsonLd['@id'] || '';

  // Check if this is a reference to something _inside_ a Repository.
  // We format these titles to represent more metadata.
  var context = extractContext(jsonLd);
  var type = extractType(jsonLd);
  var hasContextType = context && context.type;
  var hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
  if (hasContextRepo && type) {
    var contextName = context.name && "".concat(context.name, ": ") || '';
    // COMMIT: `repo-name: abf137c title of commit message`
    if (type.includes('atlassian:SourceCodeCommit')) {
      var _id$split = id.split(':'),
        _id$split2 = _slicedToArray(_id$split, 2),
        hashContent = _id$split2[1];
      var hash = hashContent && "".concat(hashContent.substring(0, 8), " ");
      return contextName + (hash || '') + name;
    }
    // PR: `repo-name: #42 title of pull request`
    if (type.includes('atlassian:SourceCodePullRequest')) {
      var pullRequest = jsonLd;
      var internalId = pullRequest['atlassian:internalId'];
      var internalIdRef = internalId && "#".concat(internalId, " ");
      return contextName + (internalIdRef || '') + name;
    }
    // BRANCH: `repo-name/branch-name`
    if (type.includes('atlassian:SourceCodeReference')) {
      return contextName + name;
    }

    // FILE: `repo-name: filepath`
    if (type.includes('schema:DigitalDocument')) {
      return contextName + name;
    }
  }
  if (removeTextHighlightingFromTitle) {
    var textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
    var truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
    return truncated;
  }
  return name;
};